export default "__VITE_ASSET__DQwcqEnC__"